// Regla única de estilos para los botones genéricos del sistema (Original y
// Costa Rica): cada acción tiene siempre el mismo color, ícono y texto.
// Úsese con `ActionButton` (@dhn/components/molecules/action-button).
export const BUTTON_VARIANTS = {
  primary: { color: "primary", className: "btn-color-primary" },
  success: { color: "success", className: "btn-color-success" },
  danger: { color: "danger", className: "btn-color-danger" },
  gray: { color: "secondary", className: "btn-color-gray" },
};

export const BUTTON_ACTIONS = {
  add: { variant: "primary", icon: "fa-plus", label: "Agregar" },
  refresh: { variant: "primary", icon: "fa-refresh", label: "Actualizar" },
  assign: { variant: "primary", icon: "fa-check", label: "Asignar" },
  resubmit: { variant: "primary", icon: "fa-paper-plane", label: "Corregir y reenviar" },
  save: { variant: "success", icon: "fa-save", label: "Guardar" },
  modify: { variant: "success", icon: "fa-check", label: "Modificar" },
  approve: { variant: "success", icon: "fa-check", label: "Aprobar" },
  audit: { variant: "success", icon: "fa-check", label: "Auditar" },
  confirm: { variant: "success", icon: "fa-check", label: "Confirmar" },
  process: { variant: "success", icon: "fa-play", label: "Procesar" },
  download: { variant: "success", icon: "fa-download", label: "Descargar" },
  edit: { variant: "gray", icon: "fa-pencil", label: "Editar" },
  view: { variant: "gray", icon: "fa-eye", label: "Ver" },
  print: { variant: "gray", icon: "fa-print", label: "Imprimir" },
  search: { variant: "primary", icon: "fa-search", label: "Buscar" },
  clear: { variant: "gray", icon: "fa-eraser", label: "Limpiar" },
  back: { variant: "gray", icon: "fa-arrow-left", label: "Atrás" },
  delete: { variant: "danger", icon: "fa-trash", label: "Borrar" },
  cancel: { variant: "danger", icon: "fa-times", label: "Cancelar" },
  close: { variant: "danger", icon: "fa-times", label: "Cerrar" },
  reject: { variant: "danger", icon: "fa-ban", label: "Rechazar" },
  deny: { variant: "danger", icon: "fa-ban", label: "Denegar" },
  unassign: { variant: "danger", icon: "fa-times", label: "Desasignar" },
};

// Texto del botón (primera palabra) → acción. Lo usa la revisión del sistema
// para detectar botones fuera de la regla.
export const ACTION_BY_LABEL = {
  agregar: "add", nuevo: "add", actualizar: "refresh", asignar: "assign",
  corregir: "resubmit", reenviar: "resubmit",
  guardar: "save", crear: "save", modificar: "modify",
  aprobar: "approve", auditar: "audit", aceptar: "confirm", confirmar: "confirm",
  procesar: "process", facturar: "process", descargar: "download", exportar: "download",
  editar: "edit", ver: "view", imprimir: "print", "re-imprimir": "print",
  buscar: "search", limpiar: "clear", "atrás": "back", atras: "back", volver: "back",
  borrar: "delete", eliminar: "delete", cancelar: "cancel", cerrar: "close", salir: "close",
  rechazar: "reject", denegar: "deny", desasignar: "unassign",
};

export const getButtonAction = (action) => {
  const config = BUTTON_ACTIONS[action];
  return config ? { ...config, ...BUTTON_VARIANTS[config.variant] } : null;
};
